"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var _require = require("../../constants/loggingLevels"),
  JSERROR = _require.JSERROR,
  ERROR = _require.ERROR;
var BaseAdapter = require("../BaseAdapter/BaseAdapter");
var NewRelicErrorProcessor = require("../../processors/NewRelic");
var NewRelicAdapter = /*#__PURE__*/function (_BaseAdapter) {
  function NewRelicAdapter(config) {
    var _this;
    (0, _classCallCheck2["default"])(this, NewRelicAdapter);
    _this = _callSuper(this, NewRelicAdapter, [config]);
    (0, _defineProperty2["default"])(_this, "processors", [NewRelicErrorProcessor]);
    (0, _defineProperty2["default"])(_this, "key", "newRelic");
    _this.name = "Logging Service - NewRelic Adapter";
    _this.nameMapping = {
      user: "User ID",
      ip: "User IP",
      interactionName: "Interaction ID",
      electronVersion: "Desktop Version"
    };
    return _this;
  }
  (0, _inherits2["default"])(NewRelicAdapter, _BaseAdapter);
  return (0, _createClass2["default"])(NewRelicAdapter, [{
    key: "addAttribute",
    value: function addAttribute(key, value) {
      var _this$nameMapping$key;
      this.attributes[(_this$nameMapping$key = this.nameMapping[key]) !== null && _this$nameMapping$key !== void 0 ? _this$nameMapping$key : key] = value;
    }
  }, {
    key: "removeAttribute",
    value: function removeAttribute(key) {
      var _this$nameMapping$key2;
      delete this.attributes[(_this$nameMapping$key2 = this.nameMapping[key]) !== null && _this$nameMapping$key2 !== void 0 ? _this$nameMapping$key2 : key];
    }
  }, {
    key: "processMessage",
    value: function processMessage(logLevel) {
      var _payload4, _payload5, _window2;
      for (var _len = arguments.length, payload = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        payload[_key - 1] = arguments[_key];
      }
      if (logLevel === JSERROR) {
        var _window, _payload, _payload2, _payload3;
        (_window = window) === null || _window === void 0 || (_window = _window.newrelic) === null || _window === void 0 || _window.noticeError((_payload = payload) === null || _payload === void 0 ? void 0 : _payload[0]);
        payload = ["An uncaught exception has occurred: ".concat((_payload2 = payload) === null || _payload2 === void 0 || (_payload2 = _payload2[0]) === null || _payload2 === void 0 ? void 0 : _payload2.toString()), (_payload3 = payload) === null || _payload3 === void 0 ? void 0 : _payload3[1]];
        logLevel = ERROR;
      }
      var _ref = typeof ((_payload4 = payload) === null || _payload4 === void 0 ? void 0 : _payload4[0]) === "string" ? [(_payload5 = payload) === null || _payload5 === void 0 ? void 0 : _payload5[0], payload.slice(1)] : ["Log message", payload],
        _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
        action = _ref2[0],
        payloads = _ref2[1];
      var attributes = _objectSpread(_objectSpread({}, this.attributes), {}, {
        "Log Level": logLevel,
        "Local Time": Date.now()
      });
      payloads.map(function (p, index) {
        var value;
        try {
          var payloadString = JSON.stringify(p);
          value = (payloadString === null || payloadString === void 0 ? void 0 : payloadString.length) > 4096 ? payloadString.slice(0, 4093) + "..." : p;
        } catch (_unused) {
          value = p;
        }
        attributes["payload".concat(index ? index : "")] = value;
      });
      (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.newrelic) === null || _window2 === void 0 || _window2.addPageAction(action, attributes);
    }
  }]);
}(BaseAdapter);
module.exports = NewRelicAdapter;